/* @jsx h */
import { defineComponent, h } from "vue";
import { LemmonModal, useLocalization } from "@lemmonhq/uikit";

export interface IgnoreReservationRequestModalProps {
  isOpen: boolean;
  loading: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const IgnoreReservationRequestModal =
  defineComponent<IgnoreReservationRequestModalProps>({
    name: "IgnoreReservationRequestModal",
    props: ["isOpen", "loading", "onClose", "onConfirm"],
    setup(props) {
      const { t } = useLocalization();

      const handleClose = () => {
        if (!props.loading) props.onClose();
      };

      return () =>
        !props.isOpen ? null : (
          <LemmonModal
            title={t("reservations.request.ignore_confirmation_title")}
            onClose={handleClose}
            hideClose={props.loading}
            disableCloseByClickingBackdrop={props.loading}
            renderButtons={() => (
              <div class="border-t border-base-300 p-4">
                <button
                  type="button"
                  class="btn btn-sm btn-error w-full"
                  disabled={props.loading}
                  onClick={props.onConfirm}
                >
                  {props.loading ? (
                    <span class="loading loading-spinner loading-xs" />
                  ) : (
                    <span class="material-symbols-outlined text-sm">
                      visibility_off
                    </span>
                  )}
                  {props.loading
                    ? t("reservations.request.ignoring")
                    : t("reservations.request.confirm_ignore")}
                </button>
              </div>
            )}
          >
            <div class="p-6">
              <div class="alert alert-warning items-start">
                <div class="flex justify-center items-center">
                  <span class="material-symbols-outlined text-sm">
                    warning
                  </span>
                  <p class="text-sm">
                    {t("reservations.request.ignore_confirmation_message")}
                  </p>
                </div>
              </div>
            </div>
          </LemmonModal>
        );
    },
  });
